import React, { useState, useEffect } from 'react';
import { Dimensions, Text, View } from 'react-native';
import PropTypes from 'prop-types';
import { Interactable } from 'LocalGluons';
import { noop } from 'Utils';
import Master from './Master';
import Detail from './Detail';
import Button from '../Button';
import NavigationService from '../../../runtime/Navigation/navigationService';
export const MASTER_VIEW_TEST_ID = 'master-view-test-id';
export const DETAIL_VIEW_TEST_ID = 'detail-view-test-id';

// eslint-disable-next-line
const detail = ({ selectedOption, onBack }) => (
    <>
        {onBack && (
            <Interactable onPress={onBack}>
                <Text>On back</Text>
            </Interactable>
        )}
        <View>
            <Text>{selectedOption.title}</Text>
        </View>
    </>
);

const findSelectedOption = (options, defaultOptionRoute) => {
    if (!defaultOptionRoute) {
        return null;
    }
    return options.find(
        ({ navigationOptions }) =>
            navigationOptions && navigationOptions.route === defaultOptionRoute
    );
};

const MasterDetail = ({
    options,
    renderWrapper,
    renderButton,
    renderDetail,
    forceLandscapeMode,
    navigation,
    defaultOptionRoute,
    onChange
}) => {
    const [dimensions, setDimensions] = useState(Dimensions.get('window'));
    const { width, height } = dimensions;
    const isLandscape = forceLandscapeMode || width > height;
    const nav = NavigationService.getTopLevelNavigationInstance().getState();
    const [selectedOption, setSelectedOption] = useState(
        findSelectedOption(options, defaultOptionRoute) || options[0]
    );

    const setDimensionsCallback = (args) => {
        setDimensions(args.window);
    };

    useEffect(() => {
        if (defaultOptionRoute) {
            const newSelectedOption = findSelectedOption(options, defaultOptionRoute);
            if (newSelectedOption) {
                setSelectedOption(newSelectedOption);
            }
        }
    }, [defaultOptionRoute]);

    useEffect(() => {
        const changeListener = Dimensions.addEventListener('change', setDimensionsCallback);
        return () => {
            changeListener.remove();
        };
    }, []);
    useEffect(() => {
        if (onChange) {
            onChange(selectedOption);
        }
    }, [selectedOption, onChange]);

    const renderMasterView = () => (
        <Master
            isLandscape={isLandscape}
            options={options}
            onSelect={setSelectedOption}
            selectedOption={selectedOption}
            renderWrapper={renderWrapper}
            renderButton={renderButton}
            renderDetail={renderDetail}
            testID={MASTER_VIEW_TEST_ID}
        />
    );

    if (isLandscape) {
        return (
            <View
                style={{
                    flexDirection: 'row',
                    flex: 1
                }}
            >
                {renderMasterView()}
                <Detail
                    navigation={navigation}
                    isLandscape={isLandscape}
                    renderDetail={renderDetail}
                    selectedOption={selectedOption}
                    testID={DETAIL_VIEW_TEST_ID}
                />
            </View>
        );
    }
    return !selectedOption ? (
        renderMasterView()
    ) : (
        <Detail
            navigation={navigation}
            testID={DETAIL_VIEW_TEST_ID}
            isLandscape={isLandscape}
            renderDetail={renderDetail}
            selectedOption={selectedOption}
            onBack={() => {
                setSelectedOption(null);
            }}
        />
    );
};

MasterDetail.defaultProps = {
    options: [],
    renderWrapper: ({ children }) => children,
    renderButton: Button,
    renderDetail: detail,
    forceLandscapeMode: false,
    defaultOptionRoute: null,
    onChange: noop
};

MasterDetail.propTypes = {
    navigation: PropTypes.shape({
        navigate: PropTypes.func.isRequired
    }).isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            navigationOptions: PropTypes.shape({
                route: PropTypes.string
            })
        })
    ),
    renderWrapper: PropTypes.func,
    renderButton: PropTypes.func,
    renderDetail: PropTypes.func,
    forceLandscapeMode: PropTypes.bool,
    defaultOptionRoute: PropTypes.string,
    onChange: PropTypes.func
};

export default MasterDetail;
